








































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import CashFlowInitialVue from "../components/CashFlowStatement/CashFlowInitial.vue";
import CashDetailedVue from "../components/CashFlowStatement/CashDetailed.vue";
import { mapGetters } from "vuex";
import AccountingSystem from "@/data/AccountingSystem";
import version from "@/version";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "cashFlow-initial": CashFlowInitialVue,
        "cash-detailed": CashDetailedVue,
    }
})
export default class CashFlowStatement extends Vue {
    accountSystem: boolean =
        this.$store.state.accountBook.accountingSystem === AccountingSystem.thirteenRule
            ? true
            : false;
    // 下载
    downLoad() {
        let url = `${Vue.axios.defaults.baseURL}export/cashflow?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&endPeriod=${this.period}&token=${this.$store.state.account.token}&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }        
    //改变时间
    period: String[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.fetchData();
    }
    cashData: CashFlow.CashData[] = [];
    // 获取表格数据
    isQiChu: boolean = true;
    fetchData() {
        let data = [];
        Vue.axios
            .post(`cash/find`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period
            })
            .then(res => {
                this.cashData = res.data.cashList;
                // 是否展示期初
                if (res.data.isShow === 0) {
                    this.isQiChu = false;
                } else {
                    this.isQiChu = true;
                }
            });
    }

    // 期初
    isInitialShow: boolean = false;
    yearPeriod: string = "";
    initialShow() {
        let period = this.period.toString();
        let year: number = Number(period.substring(0, 4));
        let month: number = Number(period.substring(4, 6)) - 1;
        if (month === 1) {
            this.yearPeriod = year + "年01月累计金额";
        } else if (month > 1 && month <= 9) {
            this.yearPeriod = year + "年01月至0" + month + "月累计金额";
        } else {
            this.yearPeriod = year + "年01月至" + month + "月累计金额";
        }
        this.isInitialShow = true;
    }
    closeInitial() {
        this.isInitialShow = false;
    }

    // 明细
    isDetailed: boolean = false
    showDetailed(){
        this.isDetailed = true
    }
    closeDetailed(){
        this.isDetailed = false
    }
}
